module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_10X_DCIS.265e5304.png";